import ContentBlock from '../components/contentBlock';
import ContentBlockItem from '../components/contentBlockItem';
import Page from '../components/page';
import RoomTypesExplainer from '../components/roomTypesExplainer';
import TextSlideShow from '../components/shared/textSlideShow';
import QuickSearch from '../containers/quickSearch/index';
import { serverSideTranslations } from '../lib/serverSideTranslations';
import { useTranslation } from '../utils/i18n';

const HomePage = () => {
  const { t } = useTranslation('common');
  // The i18n catalogue stores the testimonials as an array of objects.
  const testimonials = t('testimonials.items', {
    returnObjects: true,
  }) as Array<{ quote: string; by: string }>;

  return (
    <Page
      title={t('headers.homepage.title')}
      description={t('headers.homepage.description')}
    >
      <div className="banner" data-cy="banner">
        <div className="inner">
          <div className="banner__content">
            <h1 className="banner__heading">{t('home.title')}</h1>
            <p className="banner__intro">{t('home.subtitle')}</p>
          </div>
          <div className="banner__quickSearch">
            <QuickSearch />

            <div className="landlords-callout">
              <div className="landlords-callout__inner">
                <h2 className="landlords-callout__title">
                  {t('home.landlords_callout.title')}
                </h2>
                <p className="landlords-callout__text">
                  {t('home.landlords_callout.text')}{' '}
                  <a
                    className="landlords-callout__link"
                    href="https://www.property.nhs.uk/our-services/estate-strategy-implementation/estate-optimisation-and-space-utilisation/nhs-open-space/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('home.landlords_callout.link_text')}{' '}
                    <i className="fas fa-long-arrow-alt-right" />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main className="home_page">
        <RoomTypesExplainer
          heading={t('home.room_types.title')}
          intro={t('home.room_types.subtitle')}
          showItemButton={false}
          roomCategory="both"
          wrapImageWithLink
          wrapHeadingWithLink
          displayExplainerItemText={false}
        />

        <div className="video-block">
          <div className="video-block__wrapper">
            <iframe
              title="vimeo-player"
              data-cookieblock-src={t('vimeo-player.source')}
              data-cookieconsent="marketing"
              width="100%"
              height="100%"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>

        <ContentBlock
          title={t('core_aims_block.title')}
          subtitle={t('core_aims_block.subtitle')}
          name="core-aims"
        >
          <ContentBlockItem
            image="/images/icons/homepage/core-aims/flexibility.png"
            title={t('core_aims_block.flexibility')}
          />
          <ContentBlockItem
            image="/images/icons/homepage/core-aims/transparency.png"
            title={t('core_aims_block.transparency')}
          />
          <ContentBlockItem
            image="/images/icons/homepage/core-aims/communities.png"
            title={t('core_aims_block.communities')}
          />
          <ContentBlockItem
            image="/images/icons/homepage/core-aims/scalability.png"
            title={t('core_aims_block.scalability')}
          />
        </ContentBlock>

        <div className="testimonials-slideshow">
          <h1>{t('testimonials.title')}</h1>
          <TextSlideShow slidesArray={testimonials} />
        </div>
      </main>
    </Page>
  );
};

export const getServerSideProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

export default HomePage;
